export default () => ({
  container: {
    alignItems: 'center',
    display: 'flex',
    flexFlow: 'column',
    width: '100%',
  },
  content: {
    color: '#8D8A8F',
    display: 'grid',
    gridGap: '20px',
    gridTemplateColumns: 'repeat(4, minmax(0, 1fr))',
    justifyContent: 'center',
    width: '100%',
    maxWidth: '1155px',
    margin: '20px 0',
    boxSizing: 'border-box',
  },
  footerNote: {
    maxWidth: 720,
    textAlign: 'center',
    fontSize: '0.9rem',
    marginTop: 8,
    padding: '0 16px',
  },
  error: {
    margin: 24,
  },
});
